var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.warning)?_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"py-0"},[_c('v-alert',{staticClass:"mt-0 mb-1",attrs:{"text":"","outlined":"","dense":"","icon":"mdi-alert","type":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.warning)}})])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }